export const PageEnConstruction = () => {
  return (
    <div className="flex flex-col items-center justify-center">
        <img src="/images/logo.png" alt="Page en construction" width={400} height={400} className={"w-full"} />
      <h1 className="text-2xl font-black mb-4 font-exo text-bleu-marine">Page en construction</h1>
      <p className="text-lg text-gray-600">
        Nous travaillons actuellement sur cette page. Veuillez revenir plus tard.
      </p>
    </div>
  );
};

export const PageNotFound = () => {
  return (
    <div className="flex flex-col items-center justify-center">
        <img src="/images/logo.png" alt="Page non trouvée" width={400} height={400} className={"w-full"} />
      <h1 className="text-2xl font-black mb-4 font-exo text-bleu-marine">Page non trouvée</h1>
      <p className="text-lg text-gray-600">
        La page que vous recherchez n'a pas été trouvée.
      </p>
    </div>
  );
};